import { __assign } from '../../../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import { useCalendarCell } from 'react-aria';
import dayjs from 'dayjs';
import clsx from 'clsx';
import { useRef } from 'react';
import styles from './CalendarCell.module.scss.js';

var CalendarCell = function (_a) {
    var _b;
    var state = _a.state, date = _a.date, _c = _a.grayOutPastDate, grayOutPastDate = _c === void 0 ? true : _c;
    var ref = useRef(null);
    var _d = useCalendarCell({ date: date }, state, ref), cellProps = _d.cellProps, buttonProps = _d.buttonProps, isSelected = _d.isSelected, isOutsideVisibleRange = _d.isOutsideVisibleRange, isUnavailable = _d.isUnavailable, isDisabled = _d.isDisabled, formattedDate = _d.formattedDate;
    var inPast = dayjs(date.toString()).isBefore(new Date(), 'day');
    var isCurrentDay = dayjs(date.toString()).isSame(new Date(), 'day');
    var handleClick = function () {
        if (state.focusedDate.compare(date) > 0) {
            state.focusPreviousPage();
        }
        else {
            state.focusNextPage();
        }
        state.selectDate(date);
    };
    return (jsx("td", __assign({}, cellProps, { className: styles.calendarCell }, { children: jsx("div", __assign({}, buttonProps, { onClick: isOutsideVisibleRange ? handleClick : buttonProps.onClick, ref: ref, className: clsx(styles.day, (_b = {},
                _b[styles.selectedDay] = isSelected,
                _b[styles.currentDay] = isCurrentDay,
                _b[styles.dayInPast] = inPast && grayOutPastDate,
                _b[styles.dayOutside] = isOutsideVisibleRange,
                _b[styles.dayDisabled] = isDisabled,
                _b[styles.dayUnavailable] = isUnavailable,
                _b)) }, { children: formattedDate })) })));
};

export { CalendarCell };
